import React from 'react';
import './modal.css';
import { Icon } from '@ui';

class GenericModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      show: props.visible, // usato solo per montare il DOM
    };
    this.closeModal = this.closeModal.bind(this);
    this.stopPropagation = this.stopPropagation.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.animationTimeout = null;
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    if (this.props.visible) {
      this.enableAnimation();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    clearTimeout(this.animationTimeout);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      // apertura
      this.setState({ show: true }, this.enableAnimation);
    } else if (prevProps.visible && !this.props.visible) {
      // chiusura
      this.disableAnimation();
    }
  }

  enableAnimation = () => {
    setTimeout(() => this.setState({ active: true }), 10);
  };

  disableAnimation = () => {
    this.setState({ active: false });
    this.animationTimeout = setTimeout(() => this.setState({ show: false }), 300); // tempo animazione
  };

  handleKeyDown(e) {
    if (e.key === 'Escape' && this.props.visible) {
      this.closeModal();
    }
  }

  closeModal() {
    this.props.cancel();
  }

  stopPropagation(e) {
    e.stopPropagation();
  }

  render() {
    const modalId = this.props.id || 'generic-modal';
    const { show, active } = this.state;

    if (!show) return null;

    return (
      <div id={modalId} className={`popup ${active ? 'active' : ''}`} onClick={this.closeModal}>
        <div className="overPopup">
          <div className="contentPopup" onClick={this.stopPropagation}>
            <Icon name="close" onClick={this.closeModal} />
            <div className="row">
              <div className="col-sm-2">
                <div className="modal-ico">
                  <span className={`fa-solid fa-${this.props.ico || 'plus'}`}></span>
                </div>
              </div>
              <div className="col-sm-10">{this.props.children}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GenericModal;
